import React from 'react'
import { TextInput } from 'react-admin'

export default props => {
  return (
    <TextInput
      defaultValue={localStorage.getItem('id')}
      source={props.source || 'user.id'}
      style={{ display: 'none' }}
      disabled
    />
  )
}
